module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/logo/affirm-bw-logo-eec8cc28523e6cb268d3c104f6b960ca.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/logo/affirm-bw-logo.svg
// module id = 3jtY
// module chunks = 24